export enum VATStatus {
Normal,
Exemption,
Deduction,
WithinEU,
OutEU,
}
